<script>
export default {
  name: 'UlFormItemPhone',
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  methods: {
    submit() {
      this.$refs.input.blur();
      this.$emit('submit');
    },
  },
};
</script>
<template>
  <UlFormPhone
    v-model="module.value"
    :disabled="module.disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="submit"
  />
</template>
